module.exports = __webpack_public_path__ + "img/td.a0923ddc.svg";